import {ACTIONS} from '../../actions/website.actions';

const initialState = {
  fetchInProgress: false,
  fetchError: '',
  websites: []
}

export default (state = initialState,action) => {

  switch(action.type){

    case ACTIONS.WebsitesLoading: {
      return {
        ...state,
        fetchInProgress: true,
        fetchError: '',
        websites: []
      };
    }

    case ACTIONS.WebsitesError: {
      return {
        ...state,
        fetchInProgress: false,
        fetchError: action.payload,
        websites: []
      };
    }

    case ACTIONS.WebsitesCompleted: {
      return {
        ...state,
        fetchInProgress: false,
        fetchError: '',
        websites: action.payload
      }
    }

    case ACTIONS.WebsiteDetailsLoading: {
      return {
        ...state,
        fetchInProgress: true,
        fetchError: ''
      };
    }

    case ACTIONS.LoadMenuDetailsInProgress: {
      return {
        ...state,
        fetchInProgress: true,
        fetchError: '',
        website: {...state.website}
      };
    }

    case ACTIONS.LoadMenuDetailsCompleted: {
      return {
        ...state,
        fetchInProgress: false,
        fetchError: '',
        website: {...state.website},
        menu: action.payload
      };
    }

    case ACTIONS.LoadMenuDetailsError: {
      return {
        ...state,
        fetchInProgress: false,
        fetchError: '',
        website: {...state.website}
      };
    }

    case ACTIONS.LoadMenuGroupDetailsInProgress: {
      return {
        ...state,
        fetchInProgress: true,
        fetchError: '',
        website: {...state.website}
      };
    }

    case ACTIONS.LoadMenuGroupDetailsCompleted: {
      return {
        ...state,
        fetchInProgress: false,
        fetchError: '',
        website: {...state.website},
        menu_group: action.payload
      };
    }

    case ACTIONS.LoadMenuGroupDetailsError: {
      return {
        ...state,
        fetchInProgress: false,
        fetchError: '',
        website: {...state.website}
      };
    }

    case ACTIONS.LoadMenuItemDetailsInProgress: {
      return {
        ...state,
        fetchInProgress: true,
        fetchError: '',
        website: {...state.website}
      };
    }

    case ACTIONS.LoadMenuItemDetailsCompleted: {
      return {
        ...state,
        fetchInProgress: false,
        fetchError: '',
        website: {...state.website},
        menu_item: action.payload
      };
    }

    case ACTIONS.LoadMenuItemDetailsError: {
      return {
        ...state,
        fetchInProgress: false,
        fetchError: '',
        website: {...state.website}
      };
    }

    case ACTIONS.WebsiteDetailsError: {
      return {
        ...state,
        fetchInProgress: false,
        fetchError: action.payload,
        website: {}
      };
    }

    case ACTIONS.WebsiteDetailsCompleted: {
      return {
        ...state,
        fetchInProgress: false,
        fetchError: '',
        website: action.payload
      }
    }

    case ACTIONS.WebsiteMenuUpdateCompleted : {
      return {
        ...state,
        fetchInProgress: false,
        fetchError: '',
        website: {
          ...state.website, 
          menus: state.website.menus.map((menu)=> menuReducer(menu,action))
        }
      }
    }

    case ACTIONS.MenuAddCompleted: {
      return {
        ...state,
        fetchInProgress: false,
        fetchError: '',
        website: {
          ...state.website, 
          menus: {...state.website.menus, [action.payload._id]:action.payload}
        }
      }
    }

    default: 
      return state;
  }
};

function menuReducer(state, action){
  switch(action.type) {
    case ACTIONS.WebsiteMenuUpdateCompleted:
      if (state.id === action.payload.menu.id){
        return action.payload.menu;
      }
      return state;

      default: return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/website/index.js